export enum ETestId {
  FiltersDesktop = 'FiltersDesktop',
  ListingDesktop = 'ListingDesktop',
  ListingMobile = 'ListingMobile',
  Sidebar = 'Sidebar',
  Map = 'Map',
  Layout = 'Layout',
  Greeting = 'Greeting',
  SwipeModal = 'SwipeModal',
  SwipeModalHeader = 'SwipeModalHeader',
  SwipeModalFooter = 'SwipeModalFooter',
  SwipeModalChildren = 'SwipeModalChildren',
  SwipeModalCloseButton = 'SwipeModalCloseButton',
  SwipeModalOverlay = 'SwipeModalOverlay',
  ListingButton = 'ListingButton',
  ListingBody = 'ListingBody',
  OfferCard = 'OfferCard',
  OfferPreview = 'OfferPreview',
  OnlineBookingHighlightIcon = 'OnlineBookingHighlightIcon',
  MapOfferBoltIcon = 'MapOfferBoltIcon',
  OfferPreviewLoading = 'OfferPreviewLoading',
  OfferPreviewError = 'OfferPreviewError',
  FavoriteButton = 'FavoriteButton',
  RedesignedFiltersSectionTestId = 'RedesignedFiltersSectionTestId',
  RedesignedFiltersRegionChip = 'RedesignedFiltersRegionChip',
  RedesignedFiltersDatesChip = 'RedesignedFiltersDatesChip',
  RedesignedFiltersGuestsChip = 'RedesignedFiltersGuestsChip',
  RedesignedFiltersGuestsModalContent = 'RedesignedFiltersGuestsModalContent',
  RedesignedFiltersGuestsModalFooter = 'RedesignedFiltersGuestsModalFooter',
  RedesignedFiltersPriceChip = 'RedesignedFiltersPriceChip',
  RedesignedFiltersPriceModalContent = 'RedesignedFiltersPriceModalContent',
  RedesignedFiltersPriceModalFooter = 'RedesignedFiltersPriceModalFooter',
  RedesignedFiltersStarRatingChip = 'RedesignedFiltersStarRatingChip',
  RedesignedFiltersStarRatingModal = 'RedesignedFiltersStarRatingModal',
  RedesignedFiltersOfferTypeChip = 'RedesignedFiltersOfferTypeChip',
  RedesignedFiltersOfferTypeModal = 'RedesignedFiltersOfferTypeModal',
  CardGalleryWrapperLink = 'CardGalleryWrapperLink',
  OfferCardAuthorBranding = 'OfferCardAuthorBranding',
  MobileAppBanner = 'MobileAppBanner',
}
